/**
 * @file index.tsx
 *
 * @fileoverview Configuration for the resume wizard. What steps there are and which page is which step.
 */

import { FormattedMessage } from 'react-intl';
import {
  FrontendConfigContextType,
  getCurrentFrontendConfig,
} from '~/jobiqo/context/frontendConfig';
import { getServerFrontendConfig } from '~/jobiqo/lib/frontendConfig';
import { WizardStep } from '~/jobiqo/models/wizard';

const getRuntimeFrontendConfig = (
  frontendConfig?: FrontendConfigContextType,
) => {
  if (frontendConfig) {
    return frontendConfig;
  }

  return typeof window === 'undefined'
    ? getServerFrontendConfig()
    : getCurrentFrontendConfig();
};

export const getResumeWizardStepsInfo = (
  frontendConfig?: FrontendConfigContextType,
): WizardStep[] => {
  const runtimeFrontendConfig = getRuntimeFrontendConfig(frontendConfig);
  const resumeImportFeatureActive =
    runtimeFrontendConfig.RESUME?.RESUME_IMPORT_FEATURE_ACTIVE;
  const resumeWizardSections =
    runtimeFrontendConfig.WIZARD?.RESUME?.SHOW_SECTIONS || [];

  return [
    ...(resumeImportFeatureActive
      ? [
          {
            title: (
              <FormattedMessage
                id="resume_wizard_upload_title"
                defaultMessage="Resume upload"
              />
            ),
            page: '/resume/wizard/import',
          },
        ]
      : []),
    ...(resumeWizardSections.includes('personal_info')
      ? [
          {
            title: (
              <FormattedMessage
                id="resume_wizard_step_personal_info_title"
                defaultMessage="Personal info"
              />
            ),
            page: '/resume/wizard/personal-info',
          },
        ]
      : []),
    ...(resumeWizardSections.includes('job_preferences')
      ? [
          {
            title: (
              <FormattedMessage
                id="resume_wizard_preferences_title"
                defaultMessage="Seeker type"
              />
            ),
            page: '/resume/wizard/job-preferences',
          },
        ]
      : []),
  ];
};
